import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskSubscriptionsVm } from '../my-osk-subscriptions-vm.model';
@Injectable({ providedIn: 'root' })
export class MyOskSubscriptionsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskSubscriptions`;
  }
  get(): Observable<IMyOskSubscriptionsVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.get<IMyOskSubscriptionsVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
